import { NotificationsService } from 'angular2-notifications';
import { Contract } from './../interfaces/contract.model';
import { PaymentsService } from './../services/payments.service';
import { LocalStorageService } from './../services/local-storage.service';
import { ContractsService } from './../services/contracts.service';
import { Component, OnInit } from '@angular/core';
import { environment } from '../../environments/environment';
import { NewsService } from '../services/news.service';


@Component({
    selector: 'app-main',
    templateUrl: './news-history.component.html',
})
export class NewsHistoryComponent implements OnInit {

    
    newsHistoryListLoading: Boolean = true;
    newsHistory: any = {};

    constructor(
        private newsService: NewsService,
        private localStorageService: LocalStorageService,
        private notificationsService: NotificationsService
    ) { 
        this.newsHistoryListLoading = true;
    }

    ngOnInit() {
        this.newsHistoryListLoading = true;
        this.newsService.getHistory().subscribe(
            news => {
                this.newsHistory = news;
                this.newsHistoryListLoading = false;
            },
            (error) => {
                this.notificationsService.error('Ups', 'Błąd przy pobieraniu listy historycznych aktualności');
            }
        )
    }

}



// WEBPACK FOOTER //
// ./src/app/news/news-history.component.ts